import { Directive, HostListener, Input } from '@angular/core';
import filter from 'lodash/filter';
@Directive({
  selector: '[ivKeyPressDirective]'
})
export class KeyPressDirective {
  // tslint:disable-next-line:no-input-rename
  @Input('ivKeyPressDirective') userData;
  constructor() {
  }
  @HostListener('keydown', ['$event'])
  onInput(event: any) {
    const userRole = filter(this.userData.role, function (user) { return (user.value === 'true'); });
    const canEdit = this.userData.transaction.can_edit;
    if (userRole && userRole.length > 0 && userRole[0]) {
      const role = userRole[0]['key'];
      if (role === 'support_user') {
        if (event.which) {
          event.preventDefault();
        }
      } else if (role === 'financial_user') {
        if (event.which && !canEdit) {
          event.preventDefault();
        }
      }
    }

  }
}

